<script setup>
// --------------------------------- Imports -------------------------------- //

// ---------------------------------- Props --------------------------------- //
const props = defineProps({
  columnConfig: {
    type: Object,
    default: () => ({}),
  },
  componentConfig: {
    type: Object,
    default: () => ({}),
  },
  filterConfig: {
    type: Object,
    default: () => ({}),
  },
  operatorConfig: {
    type: Object,
    default: () => ({}),
  },
  formData: {
    type: Object,
    default: null,
  },
});
// ---------------------------------- Emits --------------------------------- //

// ---------------------------- Injects/Provides ---------------------------- //

// ----------------------- Variables - Pinia - consts ----------------------- //

// --------------------- Variables - Pinia - storeToRefs -------------------- //

// ------------------- Variables - Local - consts and lets ------------------ //

// ------------------------ Variables - Local - refs ------------------------ //

// ---------------------- Variables - Local - reactives --------------------- //

// --------------------------- Computed properties -------------------------- //
const anchor_date_options = computed(() => {
  const obj = props.operatorConfig?.options?.unit?.valueMapping || {};
  const result = Object.entries(obj).map(([_key, value]) => ({
    label: value.split('_').join(' '),
    value,
  }));
  return result;
});

const default_operator_name = computed(() => {
  return props.filterConfig?.operator_name || props.operatorConfig?.options?.unit?.valueMapping?.[props.operatorConfig.options.unit.default];
});

// -------------------------------- Functions ------------------------------- //
function onAnchorDateStartingPointChange(newVal, _oldVal, el$) {
  if (!props.formData.anchor_date_starting_time_unit && ['earlier', 'later'].includes(newVal)) {
    el$.form$.elements$.anchor_date_starting_time_unit.update(`${props.formData?.operator_name.split('_')[0]}s`);
  }
}
// -------------------------------- Watchers -------------------------------- //

// ----------------------------- Lifecycle Hooks ---------------------------- //
</script>

<template>
  <div class="col-span-12">
    <SelectElement
      name="operator_name"
      class="capitalize w-full pb-2"
      :native="false"
      :can-clear="false"
      :can-deselect="false"
      :default="default_operator_name"
      :items="anchor_date_options"
    />
    <div class="flex gap-2 items-center">
      <span class="text-xs text-gray-500 text-nowrap">Starting from</span>
      <TextElement
        name="anchor_date_starting_amount"
        class="w-1/3"
        :add-classes="{
          ElementLayout: {
            innerWrapper: 'border-b border-gray-300 mb-[0.2rem]',
          },
          ElementError: {
            container: 'hidden',
          },
          TextElement: {
            inputContainer: 'border-none',
            input: '!text-xs',
          },
        }"
        input-type="number"
        :rules="['integer', 'min:1']"
        autocomplete="off"
        :default="props.filterConfig?.anchor_date_starting_amount || 1"
        :conditions="[['anchor_date_starting_point', '!=', 'today'], ['anchor_date_starting_point', '!=', 'custom_date']]"
        @keydown.space.stop
      />
      <SelectElement
        name="anchor_date_starting_time_unit"
        class="capitalize w-2/3"
        :add-classes="{
          SelectElement: {
            select: {
              container: 'border-none',
              wrapper: 'border-b border-gray-300',
              singleLabelText: 'text-xs',
              option: 'text-xs',
            },
          },
        }"
        :default="props.filterConfig?.anchor_date_starting_time_unit"
        :can-clear="false"
        :can-deselect="false"
        :native="false"
        :conditions="[['anchor_date_starting_point', '!=', 'today'], ['anchor_date_starting_point', '!=', 'custom_date']]"
        :items="['days', 'weeks', 'months', 'quarters', 'years']"
      />
      <SelectElement
        name="anchor_date_starting_point"
        class="capitalize w-2/3"
        :add-classes="{
          SelectElement: {
            select: {
              container: 'border-none',
              wrapper: 'border-b border-gray-300',
              singleLabelText: 'text-xs',
              option: 'text-xs',
            },
          },
        }"
        :native="false"
        :default="props.filterConfig?.anchor_date_starting_point || 'today'"
        :can-clear="false"
        :can-deselect="false"
        :items="[
          { label: 'Today', value: 'today' },
          { label: 'Earlier', value: 'earlier' },
          { label: 'Later', value: 'later' },
          { label: 'Custom Date', value: 'custom_date' },
        ]"
        @change="onAnchorDateStartingPointChange"
      />
      <DateTimeElement
        :options="{
          teleport: false,
          ...componentConfig.options,
          format: 'dd-MM-yyyy',
          clearable: false,
          hideInputIcon: true,
        }"
        class="anchor_custom_date"
        :conditions="[['anchor_date_starting_point', '==', 'custom_date']]"
        :default="filterConfig?.anchor_date_starting_custom_date || null"
        name="anchor_date_starting_custom_date"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.anchor_custom_date {
  :deep(.dp__input) {
    border: none;
    @apply px-2 text-xs;
  }
}
.anchor_custom_date {
  :deep(.dp__input_wrap) {
    @apply border-b border-gray-300 mb-1;
  }
}
</style>
